/**
 * Card — calm surface primitive.
 *
 * Variants:
 *  - "default"   white surface with quiet border, generous padding
 *  - "quiet"     subtle alt background, no border
 *  - "bare"      no border, no background — pure typography
 *
 * Padding scale: "sm" 16 / "md" 24 / "lg" 32
 *
 * `hover`: when truthy, adds the restrained `card-hover` interaction state
 * (subtle shadow + border darken on hover). Use on clickable cards only.
 */
export function Card({
    variant = "default",
    padding = "md",
    className = "",
    children,
    testId,
    hover = false,
    ...rest
}) {
    const base = {
        default: "bg-white border border-stone-200 rounded-lg",
        quiet: "bg-stone-50 rounded-lg",
        bare: "",
    }[variant] ?? "bg-white border border-stone-200 rounded-lg";

    const pad = {
        none: "",
        sm: "p-4",
        md: "p-6",
        lg: "p-8",
    }[padding] ?? "p-6";

    const hoverCls = hover ? "card-hover cursor-pointer" : "";

    return (
        <div
            className={`${base} ${pad} ${hoverCls} ${className}`.trim()}
            data-testid={testId}
            {...rest}
        >
            {children}
        </div>
    );
}
